export default __webpack_public_path__ + "i18n/translations/translation-pt.0527fbe0.json";